var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('section-header',{attrs:{"breadcrumb-items":_vm.breadcrumb}})],1),_c('v-row',{staticClass:"mt-0"},[_c('alert-details'),_c('alert-triggers')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }